import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'SM',
  name: 'S.M.',
  role: 'Aerial Silks Instructor — London, UK',
  text: '"I no longer spend my Sunday evenings building class structures from scratch. I open the library, pick the class, and walk in completely prepared. My students feel the difference — and so do I."'
}, {
  initials: 'CV',
  name: 'C.V.',
  role: 'Aerial Silks Instructor — Toronto, Canada',
  text: '"The Cueing & Corrections Library alone saved me three times in my first month. That bonus is worth the full price by itself."'
}, {
  initials: 'JR',
  name: 'J.R.',
  role: 'Aerial Silks Teacher — Sydney, Australia',
  text: '"The Mixed-Level Toolkit completely changed how I teach. My progressions are smoother, my language is clearer, and my students stay focused from the very first movement to the final cool-down."'
}];
export function TestimonialsStrip() {
  return <section className="py-12 bg-dark-card border-y border-dark-border" data-id="element-250" data-mp="2cdwmkg9igupg">
      <div className="max-w-7xl mx-auto px-4" data-id="element-251" data-mp="ce0j5jr39v0p"><div className="grid md:grid-cols-3 gap-6" data-id="element-252" data-mp="cawaa92oib3p">
        {testimonials.map((testimonial, index) => <motion.div key={testimonial.initials} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-black border border-gold/20 p-6 rounded-2xl relative" data-id="element-253" data-mp="lddw4mef91q6" data-mpi={index}>
            <div className="flex gap-1 text-gold mb-4" data-id="element-254" data-mp="v25miq3u3dyz">{[...Array(5)].map((_, star) => <Star key={star} size={16} fill="currentColor" data-id="element-255" data-mp="101s75klzrwht" data-mpi={star} />)}</div>
            <p className="text-gray-300 italic mb-6 text-sm leading-relaxed" data-id="element-256" data-mp="1044phyvnw8ve">{testimonial.text}</p>
            <div className="flex items-center gap-3" data-id="element-257" data-mp="1422f32tcgwzb"><div className="w-10 h-10 rounded-full bg-gold/10 border border-gold flex items-center justify-center text-gold font-bold" data-id="element-258" data-mp="19389r66keubh">{testimonial.initials}</div><div data-id="element-259" data-mp="35xctdls38i22"><div className="font-bold text-white text-sm" data-id="element-260" data-mp="35xmi761ecj66">{testimonial.name}</div><div className="text-xs text-gold-light" data-id="element-261" data-mp="3auv2bc63uxa2">{testimonial.role}</div></div></div>
          </motion.div>)}
      </div></div>
    </section>;
}